import { createHashHistory } from "history";
import * as React from "react";
import { useState, } from 'react'
import styled, { createGlobalStyle, ThemeProvider, } from 'styled-components'
import { Provider } from "react-redux";
import { store } from "../../Shared/React/store/configureStore";


import ErrorHandler from "../../Shared/React/components/ErrorHandler";
import InvoicePage from "./components/InvoicePage";

export const history = createHashHistory();

const App = (props: MainProps): JSX.Element => {
    
    return (
            <div>
                {props.permissions && props.permissions.commercial != null && props.permissions.residential != null ? (<div>
                    <Provider store={store}>
                        <div>
                            <ErrorHandler />
                        <InvoicePage canViewCommercial={props.permissions.commercial} canViewResidential={props.permissions.residential} />
                        </div>
                    </Provider>
                </div>) : null}
            </div>
    );
}

export default App;

interface MainProps {
    permissions: {
        commercial: boolean;
        residential: boolean;
    };
}
